var e = /* @__PURE__ */ ((r) => (r.Always = "always", r.Never = "never", r.Adaptive = "adaptive", r))(e || {}), c = /* @__PURE__ */ ((r) => (r.Medium = "medium", r.Small = "small", r))(c || {}), a = /* @__PURE__ */ ((r) => (r.Start = "start", r.End = "end", r))(a || {}), t = /* @__PURE__ */ ((r) => (r.Primary = "primary", r.PrimaryDestructive = "primaryDestructive", r.PrimarySuccess = "primarySuccess", r.Secondary = "secondary", r.SecondaryDestructive = "secondaryDestructive", r.SecondarySuccess = "secondarySuccess", r.Brand = "brand", r))(t || {});
const s = [
  "primaryDestructive",
  "secondaryDestructive"
  /* SecondaryDestructive */
], o = {
  start: ["IconPlus", "IconCheckInCircle", "IconListView1"],
  end: [
    "IconShare",
    "IconExternalLink",
    "IconArrowRight",
    "IconDownload",
    "IconGear",
    "IconInfo"
  ]
};
export {
  e as FullWidthEnum,
  a as IconPositionEnum,
  o as MEDIUM_ICON_NAMES,
  c as SizesEnum,
  t as VariantsEnum,
  s as destructiveVariants
};
